module.exports = __webpack_public_path__ + "static/bd.58ee8a2c.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/services/bd.png
// module id = 149
// module chunks = 35783957827783 269829036549620